<template>
  <div>
    <div class="md-layout md-gutter" v-if="billingPrice.recurring.usageType === 'metered'">
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading mb-0">{{ $t('fields.billing.subscriptionType') }}</p>
        <span>{{ $t(`billing.usageTypes.${billingPrice.recurring.usageType}`) }}</span>
      </div>
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading mb-0">{{ $t('fields.billing.unitAmount') }}</p>
        <span>{{ billingPrice.unitAmount | toCurrency }} per document</span>
      </div>
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading mb-0">{{ $t('fields.billing.schedule') }}</p>
        <span>
          {{ $tc('billing.schedule') }}
          {{ $tc('billing.intervalCount', billingPrice.recurring.intervalCount) }}
          {{ $tc(
            `billing.intervals.${billingPrice.recurring.interval}`,
            billingPrice.recurring.intervalCount)
          }}
        </span>
      </div>
    </div>
    <div class="md-layout md-gutter" v-if="billingPrice.recurring.usageType === 'licensed'">
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading mb-0">{{ $t('fields.billing.subscriptionType') }}</p>
        <span>{{ $t(`billing.usageTypes.${billingPrice.recurring.usageType}`) }}</span>
      </div>
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading mb-0">{{ $t('fields.billing.unitAmount') }}</p>
        <span>
          {{ billingPrice.unitAmount | toCurrency }} per {{ billingPrice.recurring.interval }}
        </span>
      </div>
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading mb-0">{{ $t('fields.billing.schedule') }}</p>
        <span>
          {{ $tc('billing.schedule') }}
          {{ $tc('billing.intervalCount', billingPrice.recurring.intervalCount) }}
          {{ $tc(
            `billing.intervals.${billingPrice.recurring.interval}`,
            billingPrice.recurring.intervalCount)
          }}
        </span>
      </div>
    </div>
    <div class="md-layout md-gutter">
      <div
        class="md-layout-item md-small-size-100 mb-1"
        v-if="billingPrice.recurring.usageType === 'licensed'"
      >
        <p class="md-subheading mb-0">{{ $t('fields.billing.quota') }}</p>
        <span>{{ quota || billingPrice.metadata.quota || $t('fields.billing.notSet') }}</span>
      </div>
      <div
        class="md-layout-item md-small-size-100 mb-1"
        v-if="billingPrice.recurring.usageType === 'licensed'"
      >
        <p class="md-subheading mb-0">{{ $t('fields.billing.quotaRenewal') }}</p>
        <span>{{ $t(`fields.billing.quotaRenewals.${billingPrice.metadata.quotaRenewal}`) }}</span>
      </div>
      <div class="md-layout-item md-size-33 md-small-size-100 mb-1">
        <p class="md-subheading mb-0">{{ $t('fields.billing.kind') }}</p>
        <span>{{ kindName(kind || billingPrice.metadata.kind) }}</span>
      </div>
    </div>
    <div class="md-layout md-gutter">
      <div
        class="md-layout-item md-size-33 md-small-size-100 mb-1"
        v-if="billingPrice.recurring.usageType === 'licensed'"
      >
        <p class="md-subheading mb-0">{{ $t('fields.billing.overageUnitAmount') }}</p>
        <span v-if="billingPrice.metadata.overageUnitAmount >= 0">
          {{ (overageUnitAmount || billingPrice.metadata.overageUnitAmount) | toCurrency }}
        </span>
        <span v-if="!billingPrice.metadata.overageUnitAmount">
          {{ $t('fields.billing.notSet') }}
        </span>
      </div>
      <div class="md-layout-item md-size-33 md-small-size-100 mb-1">
        <p class="md-subheading mb-0">{{ $t('fields.billing.smsUnitAmount') }}</p>
        <span v-if="!hasSmsAmount">
          {{ $t('fields.billing.notSet') }}
        </span>
        <span v-if="hasSmsAmount">
          {{ (smsUnitAmount || billingPrice.metadata.smsUnitAmount) | toCurrency }} {{
            $t('base.perSms')
          }}
        </span>
      </div>
    </div>
  </div>
</template>
<script type="ts">
import Vue from 'vue';
import BillingPrice from '@/datatypes/billing/price';
import User from '@/datatypes/user';

export default Vue.extend({
  name: 'billing-price-structure',
  props: {
    billingPrice: {
      type: BillingPrice,
      default: new BillingPrice({}),
    },
    quota: {
      type: Number,
      default: undefined,
    },
    overageUnitAmount: {
      type: Number,
      default: undefined,
    },
    smsUnitAmount: {
      type: Number,
      default: undefined,
    },
    kind: {
      type: Number,
      default: undefined,
    },
  },

  data: () => ({
    received: false,
    user: new User({}),
  }),

  methods: {
    kindName(value) {
      if ((typeof value === 'undefined') || (value === null)) {
        return this.$t('fields.billing.notSet');
      }

      return this.user.kindHash.find(
        (item) => item.kind === value,
      )?.name;
    },
  },

  computed: {
    hasSmsAmount() {
      if (!this.billingPrice) return false;

      if (
        (typeof this.billingPrice.metadata.smsUnitAmount === 'undefined')
        || (this.billingPrice.metadata.smsUnitAmount === null)
      ) {
        return false;
      }

      return true;
    },
  },
});
</script>
